import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { CertificateStateComponent } from './certificate-state/certificate-state.component';
import { ConnectionStateComponent } from './connection-state/connection-state.component';
import { DeviceStateComponent } from './device-state/device-state.component';
import { DevicesComponent } from './devices.component';
import { DevicesEffects } from './devices.effects';
import { devicesFeatureKey } from './devices.models';
import { devices } from './devices.reducer';
import { AddDevicesDialogComponent } from './dialogs/add-devices-dialog/add-devices-dialog.component';
import { EditDevicesDialogComponent } from './dialogs/edit-devices-dialog/edit-devices-dialog.component';
import { FirmwareDialogComponent } from './dialogs/firmware-dialog/firmware-dialog.component';
import { MasterPasswordDialogComponent } from './dialogs/master-password/master-password.component';
import { FirmwareStateComponent } from './firmware-state/firmware-state.component';
import { LinkStateComponent } from './link-state/link-state.component';
import { ErrorMessagesPipe } from './pipes/error-message.pipe';
import { HasErrorPipe } from './pipes/has-error.pipe';

@NgModule({
    imports: [
        SharedModule,
        StoreModule.forFeature(devicesFeatureKey, devices),
        EffectsModule.forFeature([DevicesEffects]),
        TranslocoModule,
    ],
    exports: [DevicesComponent, AddDevicesDialogComponent, EditDevicesDialogComponent],
    declarations: [
        DevicesComponent,
        AddDevicesDialogComponent,
        EditDevicesDialogComponent,
        CertificateStateComponent,
        FirmwareStateComponent,
        ConnectionStateComponent,
        MasterPasswordDialogComponent,
        LinkStateComponent,
        FirmwareDialogComponent,
        DeviceStateComponent,
        HasErrorPipe,
        ErrorMessagesPipe,
    ],
    providers: [HasErrorPipe, ErrorMessagesPipe],
})
export class DevicesModule {}
